var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadLinkV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    rx: 6,
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9915 15.9956C13.4233 16.573 13.9744 17.0508 14.6071 17.3965C15.2399 17.7422 15.9396 17.9478 16.6588 17.9993C17.378 18.0508 18.0999 17.947 18.7754 17.695C19.451 17.443 20.0645 17.0486 20.5743 16.5387L23.5913 13.5217C24.5072 12.5733 25.0141 11.3031 25.0026 9.98469C24.9912 8.66626 24.4623 7.40508 23.53 6.47278C22.5977 5.54048 21.3365 5.01165 20.0181 5.00019C18.6997 4.98873 17.4295 5.49557 16.4812 6.41153L14.7514 8.13123",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0114 13.9843C16.5795 13.4069 16.0284 12.9291 15.3957 12.5834C14.7629 12.2377 14.0632 12.0321 13.344 11.9806C12.6248 11.9291 11.9029 12.0329 11.2274 12.2849C10.5518 12.5369 9.93832 12.9312 9.42855 13.4412L6.41153 16.4582C5.49557 17.4066 4.98873 18.6768 5.00019 19.9952C5.01165 21.3136 5.54048 22.5748 6.47278 23.5071C7.40508 24.4394 8.66626 24.9682 9.98469 24.9797C11.3031 24.9911 12.5733 24.4843 13.5217 23.5684L15.2414 21.8486",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadLinkV2);
export default __webpack_public_path__ + "static/media/upload-link-v2.5fae84c27a6db61199d75f53e3acccb3.svg";
export { ForwardRef as ReactComponent };